"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _HBSlider = require("./HBSlider.styles");
var _useDebouncedCallback = require("../common/useDebouncedCallback");
var _useBuildTestIdInternal = require("../common/internal/useBuildTestIdInternal");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function useHBSlider(_ref) {
  var value = _ref.value,
    debounceMs = _ref.debounceMs,
    onChange = _ref.onChange;
  var _useState = (0, _react.useState)(value),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    innerValue = _useState2[0],
    setInnerValue = _useState2[1];
  var debouncedOnChange = (0, _useDebouncedCallback.useDebouncedCallback)(function (val) {
    onChange(val);
  }, debounceMs || 500);
  if (!debounceMs) {
    return {
      value: value,
      onChange: onChange
    };
  }
  return {
    value: innerValue,
    onChange: function onChange(val) {
      setInnerValue(val);
      debouncedOnChange(val);
    }
  };
}
var Container = _styledComponents["default"].div.withConfig({
  displayName: "HBSlider__Container",
  componentId: "sc-1t4e88g-0"
})(["position:relative;"]);
var HBSlider = function HBSlider(_ref2) {
  var id = _ref2.id,
    testIdName = _ref2.testIdName,
    testId = _ref2.testId,
    onChange = _ref2.onChange,
    minValue = _ref2.minValue,
    maxValue = _ref2.maxValue,
    stepSize = _ref2.stepSize,
    _ref2$value = _ref2.value,
    value = _ref2$value === void 0 ? 0 : _ref2$value,
    disabled = _ref2.disabled,
    debounceMs = _ref2.debounceMs,
    className = _ref2.className;
  var _useHBSlider = useHBSlider({
      value: value,
      debounceMs: debounceMs,
      onChange: onChange
    }),
    _value = _useHBSlider.value,
    _onChange = _useHBSlider.onChange;
  var finalTestId = (0, _useBuildTestIdInternal.useBuildTestIdInternal)({
    testId: testId,
    identifier: testIdName || id,
    suffix: 'slider-wrapper',
    componentName: 'HBSlider'
  });
  var handleValueChange = function handleValueChange(values) {
    _onChange(values[0]);
  };
  return /*#__PURE__*/_react["default"].createElement(Container, {
    className: className,
    "data-testid": finalTestId
  }, /*#__PURE__*/_react["default"].createElement(_HBSlider.SliderRoot, {
    value: [_value],
    onValueChange: handleValueChange,
    max: maxValue,
    min: minValue,
    step: stepSize || 1,
    disabled: disabled,
    name: id,
    "aria-label": id
  }, /*#__PURE__*/_react["default"].createElement(_HBSlider.SliderTrack, null, /*#__PURE__*/_react["default"].createElement(_HBSlider.SliderRange, null)), /*#__PURE__*/_react["default"].createElement(_HBSlider.SliderThumb, {
    "aria-label": "".concat(id, " slider")
  })), /*#__PURE__*/_react["default"].createElement(_HBSlider.ValueLabel, {
    htmlFor: id
  }, _value));
};
var _default = exports["default"] = HBSlider;
//# sourceMappingURL=HBSlider.js.map